import { create } from 'zustand';

// BK-06 : levé par l'api-client quand un 401 survient avec un brouillon
// actif — la ReauthModal (montée à la racine) prend le relais au lieu d'une
// redirection dure qui jetterait l'état SPA (donc le brouillon).
interface SessionState {
  reauthRequired: boolean;
  setReauthRequired: (v: boolean) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  reauthRequired: false,
  setReauthRequired: (v) => set({ reauthRequired: v }),
}));
